@if (buttonData(); as buttonData) {
  <ess-button
    [class]="buttonData.class"
    [buttonType]="'button'"
    (buttonClicked)="openConfirmation()"
    data-cy="confirmation-button"
  >
    {{ buttonData.text }}
  </ess-button>
}
